<template>
  <div class="normal-courses">
    <div class="is-flex">
      <div class="course" v-for="(item, index) in items" :key="index">
        <article class="media">
          <div class="media-content">
            <div class="content">
              <p>
                <router-link :to="{name : 'course', params : {slug : item.slug}}">
                  <strong :title="item.title">{{ item.title}}</strong>
                </router-link>
                <span>{{item.description}}</span>
              </p>
            </div>
          </div>
          <div class="media-right">
            <p class="image" v-lazy-container="{selector : 'img'}">
              <img :data-src="item.image" />
            </p>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: 5
    };
  },
  props: {
    courses: {
      type: Array
    },
    expand: {
      type: Boolean
    },
    limit: {
      type: Number
    }
  },
  computed: {
    items() {
      if (this.expand) {
        return this.courses
      }
      return this.courses.slice(0, this.limit)
    }
  },
  created() {
		this.courses.sort((a, b) =>  a.sort - b.sort)
  }
};
</script>

<style lang="scss">
.normal-courses {
  width: 100%;
  margin-top: 16px;
  .is-flex {
    flex-wrap: wrap;
  }
  .course {
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
    margin-right: 10px;
    margin-bottom: 16px;
    border-radius: 4px;
    padding: 10px;
    background: #fff;
    .media {
      // max-width: 100%;
      // height: 110px;
      width: 300px;
      height: 123px;
      .media-content {
        p {
          font-size: 14px;
          color: #7a8189;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          font-size: 400 !important;
          a {
            color: #000000;
          }

          strong {
            font-size: 16px;
            margin-bottom: 5px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            cursor: pointer;
          }
        }
      }

      .media-right {
        img {
          border-radius: 3px;
          width: 90px;

        }
      }
    }
  }
}
@media screen and (min-width: 320px) and (max-width: 767px) {
  .normal-courses {
    .course {
      width: 100%;
      margin-right: 0;

      .media {
        width: 100%;
        height: 110px;
      }
    }
  }
}
</style>
